import { render, staticRenderFns } from "./MyFoldersView.vue?vue&type=template&id=0ce962b7&scoped=true"
import script from "./MyFoldersView.vue?vue&type=script&lang=js"
export * from "./MyFoldersView.vue?vue&type=script&lang=js"
import style0 from "./MyFoldersView.vue?vue&type=style&index=0&id=0ce962b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce962b7",
  null
  
)

export default component.exports